import React, { FC, useState } from 'react';

import { Grid } from '@material-ui/core';
import moment from 'moment';
import CopyToClipboard from 'react-copy-to-clipboard';

import { IClubInvitation } from '../../../../store/clubInvitations/store';

import { ClubPendingInvitationsRowStyled } from './ClubPendingInvitations.Styles';
import { APP_ENV_SUBDOMAIN } from '../../../../contrib/Utils/APP_ENV_SUBDOMAIN';

interface IProps {
  invitation: IClubInvitation;
}

const ClubPendingInvitationsRow: FC<IProps> = props => {
  const { invitation } = props;

  const [copySuccess, setCopySuccess] = useState(false);

  const onCopy = (): void => {
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 5 * 1000);
  };

  const invitationURL = `${APP_ENV_SUBDOMAIN}.wagl.golf/register/set-code/?invitationCode=${
    invitation.key
  }`;

  return (
    <ClubPendingInvitationsRowStyled
      container={true}
      key={`pending-invitation-${invitation.email}`}
    >
      <Grid className="grid-item" item={true} xs={6}>
        {invitation.email}
      </Grid>

      <Grid className="grid-item" item={true} xs={2}>
        {moment(invitation.sent).format('MM/DD/YY')}
      </Grid>

      <Grid className="grid-item" item={true} xs={2}>
        {invitation.key}
      </Grid>

      <Grid className="grid-item" item={true} xs={2}>
        <CopyToClipboard text={invitationURL} onCopy={onCopy}>
          <div className="copy-widget-cta">
            <span className="message">{copySuccess ? 'Copied' : 'Copy Link'}</span>
          </div>
        </CopyToClipboard>
      </Grid>
    </ClubPendingInvitationsRowStyled>
  );
};

export default ClubPendingInvitationsRow;
